import React from "react";
import { Spin } from "antd";
import style from "./index.module.scss";

export default function PageSpin() {
    return (
        <div className={style.root}>
            <Spin />
        </div>
    );
}
